export default __webpack_public_path__ + "static/onboarding1-fa9de0be084db9aa3cde99d4c5467f89.png";